module.exports = "/matchcenter-staging/assets/images/alpha.31fecbe72666cd40d19814a130f23afc.png";